import FormComponent from "../FormComponent";
import SelectComponentProps from "./types";
import Select from 'react-select';
import { styleSelect } from "_metronic/helpers/SelectStyles";

const SelectComponent: React.FC<SelectComponentProps> = ({
    name,
    label,
    required,
    formData,
    options,
    disabled = false,
    topTooltip,
    bottomTooltip,
    leftTooltip,
    rightTooltip,
    display
}) => {
    return (
        <FormComponent
            name={name}
            label={label}
            required={required}
            formData={formData}
            topTooltip={topTooltip}
            bottomTooltip={bottomTooltip}
            leftTooltip={leftTooltip}
            rightTooltip={rightTooltip}
            display={display}
        >
            <Select
                isDisabled={disabled}
                name={name}
                options={options}
                styles={styleSelect}
                placeholder={"Seleccione"}
                isSearchable={true}
                noOptionsMessage={() => (
                    <span>{"No se encontraron registros"}</span>
                )}
                value={formData.getFieldProps(name)?.value}
                onChange={(value) => {
                    formData.setFieldValue(name, value)
                }}
                backspaceRemovesValue
            />
        </FormComponent>
    );
};

export default SelectComponent;